import { all } from 'redux-saga/effects';

import { loadSettingsSaga } from './loadSettings';
import { updateSettingsSaga } from './updateSettings';

export function* saga() {
    yield all([loadSettingsSaga(), updateSettingsSaga()]);
}
